// UN QR VIVO EN ESTE NAVEGADOR (dueño, 13-oct-2026).
//
// Un QR sin pagar sigue cobrable ~15 min. Si el comprador lo deja vivo y vuelve a pagar lo mismo
// (por «Otros medios» o con otro QR), paga dos veces. El servidor frena eso (409 `qr_pendiente`);
// esto lo frena ANTES, sin ir al servidor, y le dice al comprador hasta qué hora vale el QR.
//
// «Lo mismo» = la misma visita (`visita:<quote_id>`) o el mismo conjunto de SKU de la Tienda —
// la misma llave que usa `server/routes/pagos.js` (`claveDeCompra`).

const LLAVE = 'sh:qr-vivo';
const VIDA_MS = 15 * 60 * 1000;

export function claveTienda(skus) {
  return `tienda:${(skus || []).map((s) => String(s || '')).filter(Boolean).sort().join(',')}`;
}

export function claveVisita(quoteId) {
  return `visita:${quoteId}`;
}

/** El QR vivo para esta compra, o `null` si no hay o ya venció. */
export function qrVivo(clave) {
  try {
    const x = JSON.parse(sessionStorage.getItem(LLAVE) || 'null');
    if (x && x.clave === clave && Date.parse(x.vence) > Date.now()) return x;
  } catch (_) { /* sin sessionStorage: decide el servidor */ }
  return null;
}

export function guardarQrVivo(clave, ref, vence) {
  try {
    const v = vence && Number.isFinite(Date.parse(vence)) ? vence : new Date(Date.now() + VIDA_MS).toISOString();
    sessionStorage.setItem(LLAVE, JSON.stringify({ clave, ref, vence: v }));
  } catch (_) { /* sin sessionStorage: decide el servidor */ }
}

export function mensajeQrVivo(x) {
  const hora = new Date(x.vence).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
  return `Tienes un QR de pago vigente hasta las ${hora}. Págalo con ese QR o espera a que venza para usar otro medio: así no pagas dos veces.`;
}
